import React, { useRef, useEffect } from 'react';
import { FeaturedCTAProps } from './config';
import classNames from 'classnames';
import { sanitizeHTML } from 'utils/SecurityHelper';
import './styles.scss';

const FeaturedCTA = ({
  heading,
  headingType,
  displayType,
  verticalAlign,
  horizonatlAlign,
  backgroundcolor,
  textColor,
  addborder,
  opacity,
  maskcolor,
  description,
  primarybuttonortext,
  primarybuttontext,
  primarybuttonurl,
  primaryopeninanewtab,
  primaryincludearrow,
  secondarybuttonortext,
  secondarybuttontext,
  secondarybuttonurl,
  secondaryopeninanewtab,
  secondaryincludearrow,
  fileReference,
  ctaimagealt,
}: FeaturedCTAProps) => {
  const featureCTAHeading = useRef<HTMLDivElement>(null!);
  const featureTileClassses = classNames({
    'feature-tile': true,
    'fn_feature-tile': true,
    'feature-tile--cta': true,
    [`${verticalAlign}`]: verticalAlign !== 'top',
    [`${horizonatlAlign}`]: horizonatlAlign !== 'left',
    'feature-tile--with-image': fileReference,
    'feature-tile--bordered': addborder,
    [`${backgroundcolor}`]: true,
    [`${textColor}`]: textColor,
  });

  const featureTileMaskStyles = {
    opacity,
    backgroundColor: maskcolor,
  };

  const headingRenderer = () => {
    const headingHTML = heading
      ? `<${displayType ? 'div' : headingType} ${
          displayType ? 'class=' + headingType : ''
        }> ${heading} </${displayType ? 'div' : headingType}>`
      : '';

    if (featureCTAHeading.current) {
      featureCTAHeading.current.innerHTML = headingHTML;
    }
  };

  useEffect(() => {
    if (window.grunticon) {
      window.grunticon.embedIcons(
        window.grunticon.getIcons(window.grunticon.getCSS(window.grunticon.href))
      );
    }
    headingRenderer();
  }, []);

  return heading || description || fileReference ? (
    <div className="tu-featured-cta">
      <div className="module module--feature-tile">
        <div className="module__content l-full-width">
          <div className={featureTileClassses}>
            {fileReference && (
              <div className="feature-tile__image-container">
                <img
                  src={fileReference}
                  alt={ctaimagealt}
                  className="feature-tile__image"
                />
                <span className="feature-tile__mask" style={featureTileMaskStyles}>
                  &nbsp;
                </span>
              </div>
            )}
            <div className="feature-tile__content">
              <div className="feature-tile__title" ref={featureCTAHeading}></div>
              <div
                className="feature-tile__text"
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }}
              ></div>
              <div className="feature-tile__cta-container">
                {primarybuttontext && primarybuttonurl && (
                  <a
                    href={primarybuttonurl}
                    className={`btn btn--${
                      primarybuttonortext === 'text'
                        ? 'link feature-tile__cta-secondary fn_feature-tile__cta-secondary'
                        : primarybuttonortext + ' feature-tile__cta fn_feature-tile__cta'
                    } btn--small`}
                    target={`${primaryopeninanewtab ? '_blank' : ''}`}
                  >
                    {primarybuttontext}
                    {primaryincludearrow && (
                      <span
                        className="icon icon--arrow-right"
                        data-grunticon-embed="true"
                      ></span>
                    )}
                  </a>
                )}
                {secondarybuttontext && secondarybuttonurl && (
                  <a
                    href={secondarybuttonurl}
                    className={`btn btn--${
                      secondarybuttonortext === 'text'
                        ? 'link feature-tile__cta-secondary fn_feature-tile__cta-secondary'
                        : secondarybuttonortext +
                          ' feature-tile__cta fn_feature-tile__cta'
                    } btn--small`}
                    target={`${secondaryopeninanewtab ? '_blank' : ''}`}
                  >
                    {secondarybuttontext}
                    {secondaryincludearrow && (
                      <span
                        className="icon icon--arrow-right"
                        data-grunticon-embed="true"
                      ></span>
                    )}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default FeaturedCTA;
